import React from "react";
import SimpleBanner from "../Common/SimpleBanner";
import Aboutbanar from "../../Assets/About/aboutbg.png";
import OurTeam from "../../Components/About Us/OurTeam";
import TheWandererGuide from "../../Components/About Us/TheWandererGuide";
import VisionMission from "../../Components/About Us/VisionMission";
import WhyChooseUs from "../../Components/About Us/WhyChooseUs";
import ClientsTestimonials from "../../Components/About Us/ClientsTestimonials";
import VehicleServices from "../../Components/Tour/VehicleService";
import Newsletter from "../../Components/home/Newsletter";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <div className="overflow-x-hidden">
      <Helmet>
        <title>About GoCabz – Trusted Cab Booking Service in Bhubaneswar</title>
        <meta
          name="description"
          content="Learn about GoCabz, a trusted cab booking service in Bhubaneswar. We are committed to safe, comfortable, and reliable rides with professional drivers."
        />
        <link rel="canonical" href="https://www.gocabz1.com/about/" />
      </Helmet>
      <SimpleBanner image={Aboutbanar} name="About Us" path="Home / About Us" />
      <TheWandererGuide />
      <WhyChooseUs />
      <VisionMission />
      <ClientsTestimonials />
      <VehicleServices />
      <Newsletter />
    </div>
  );
};

export default About;
